import * as React from "react";
const SvgCheck = props => <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 12 9" {...props}><path fill="none" stroke="currentColor" strokeWidth={1.6} d="M1.519 4.53 4.43 7.666l6.05-6.519" /></svg>;
export default SvgCheck;